// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'cloud-nodes';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M13.037 10.381c1.7 0 3.046-1.346 3.046-3.046 0-1.7-1.345-3.045-3.045-3.045-.638 0-1.205.212-1.7.566C10.913 2.66 9 1.031 6.733 1.031a4.67 4.67 0 0 0-4.675 4.675 4.67 4.67 0 0 0 4.675 4.675zM9 16.969a1.417 1.417 0 1 0 0-2.833 1.417 1.417 0 0 0 0 2.833zm-6.375-.354a1.417 1.417 0 1 0 0-2.834 1.417 1.417 0 0 0 0 2.834zm12.75 0a1.417 1.417 0 1 0 0-2.834 1.417 1.417 0 0 0 0 2.834z' />
    <path d='M3.758 14.348 9 10.397v3.735m5.242.216L9 10.397' />
  </g>
);

export const viewBox = '0 0 18 18';
